import { sendGAEvent } from '../utils';

enum SearchGamesEventsEnum {
  search_overall_appearance = 'search_overall_appearance',
  search_result_appearance = 'search_result_appearance',
  search_result_game_open = 'search_result_game_open',
}

type TSearchOverallAppearanceType = 'filter' | 'tabbar';

/**
 *
 * @param { TSearchOverallAppearanceType } type  - The type of search form appearance.
 * @description This function sends a Google Analytics event when the search form appears.
 * It uses the `gtag` function to send the event with the specified type.
 */
export const sendSearchOverallAppearanceEvent = (
  type?: TSearchOverallAppearanceType
) => {
  sendGAEvent(SearchGamesEventsEnum.search_overall_appearance, {
    event_category: 'search',
    type: type || 'filter',
  });
};

type TSearchResultAppearanceStatusType = 'success' | 'empty_results' | 'error';

interface ISearchResultAppearanceEventData {
  search_text: string;
  search_text_sent: string;
  status?: TSearchResultAppearanceStatusType;
  error_text?: string;
}

/**
 *
 * @param {ISearchResultAppearanceEventData} - The object containing search event details.
 * @description This function sends a Google Analytics event when the search form is submitted.
 * It uses the `gtag` function to send the event with the specified data.
 * The data object should contain the following properties:
 */
export const sendSearchResultAppearanceEvent = ({
  search_text,
  search_text_sent,
  status,
  error_text,
}: ISearchResultAppearanceEventData) => {
  sendGAEvent(SearchGamesEventsEnum.search_result_appearance, {
    event_category: 'search',
    search_text,
    search_text_sent,
    status: status || 'success',
    ...(status === 'error' && error_text ? { error_text } : {}),
  });
};

interface ISearchResultGameOpenEventData {
  type: string;
  provider: string;
  game_name: string;
}

/**
 *
 * @param {ISearchResultGameOpenEventData} - The object containing open game in search modal event details.
 * @description This function sends a Google Analytics event when the game is opening.
 * It uses the `gtag` function to send the event with the specified data.
 * The data object should contain the following properties:
 */
export const sendSearchResultGameOpenEvent = ({
  type,
  provider,
  game_name,
}: ISearchResultGameOpenEventData) => {
  sendGAEvent(SearchGamesEventsEnum.search_result_game_open, {
    event_category: 'search',
    type,
    provider,
    game_name,
  });
};
